<template>
	<div>
		<div v-if="isValid">
			<div class="md-layout" v-if="registration_success">
				<div class="md-layout-item" style="text-align: center;line-height: 32px;">
					<h3 style="color: green;">
						<b>{{$store.state.locale.locale.successRegistration[$store.state.locale.lang]}}</b>
					</h3>
					<div>
						<md-icon
							style="color:green;font-size: 100px !important;height:100px !important; width: 100px !important;">
							check_circle</md-icon>
					</div>

					<h4>{{$store.state.locale.locale.thankyou[$store.state.locale.lang]}}</h4>
					<!-- <h3>{{$store.state.locale.locale.refText[$store.state.locale.lang]}} {{reference_code}}</h3> -->
					<!-- <div style="width: 100%; display: flex; justify-content: center;">
					<qr-code :text="reference_code" :size="200" style="width:200px;border:10px solid white"></qr-code>
				</div> -->
					<div class="md-layout-item md-small-size-100 md-size-100 text-center">
						<md-button class="md-primary" style="width: 100%" @click="$router.push('/pass/'+hash_id)">
							<h4><b>{{$store.state.locale.locale.openTicket[$store.state.locale.lang]}}</b></h4></md-button>
					</div>
					<h4>
						{{$store.state.locale.locale.saveRefCode[$store.state.locale.lang]}}<br>{{$store.state.locale.locale.refCodeDetail[$store.state.locale.lang]}}
					</h4>
				</div>
			</div>
			<div v-if="!registration_success">
				<div class="md-layout">
					<div class="md-layout-item md-small-size-100 md-size-100" style="margin-top: 21px">
						<img src="@/assets/img/head.jpeg" />
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100" style="margin-top: 21px">
						<img src="@/assets/img/banner1.png" />
					</div>
					<!-- <div class="md-layout-item md-small-size-100 md-size-100" style="margin-top: 21px; margin-bottom: 21px;">
						<img src="@/assets/img/header.png" />
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100" style="margin-top: 8px; text-align: center;">
						<b>Hosted & Organized By</b>
						<img src="@/assets/img/host.png" />
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100" style="margin-top: 8px; text-align: center;">
						<b>Supported By</b>
						<img src="@/assets/img/support.png" />
					</div>
					<div class="md-layout-item md-small-size-50 md-size-50" style="margin-top: 8px; text-align: center;">
						<b>Diamond Sponsors</b>
						<img src="@/assets/img/diamond.png" />
					</div>
					<div class="md-layout-item md-small-size-50 md-size-50" style="margin-top: 8px; text-align: center;">
						<b>Gold Sponsors</b>
						<img src="@/assets/img/gold.png" />
					</div>
					<div class="md-layout-item md-small-size-50 md-size-50" style="margin-top: 8px; text-align: center;">
						<b>Silver Sponsors</b>
						<img src="@/assets/img/silver.png" />
					</div>
					<div class="md-layout-item md-small-size-50 md-size-50" style="margin-top: 8px; text-align: center;">
						<b>Bronze Sponsors</b>
						<img src="@/assets/img/bronze.png" />
					</div> -->
				<!-- <div class="md-layout-item md-small-size-100 md-size-50" style="margin-top: 8px;">
					<img src="@/assets/img/sponsor1.png" />
				</div> -->
					<div class="md-layout-item md-size-100">
						<!-- {{registration_hash}} {{registration_id}} -->
						<p style="margin-top: 21px">
							<b>{{$store.state.locale.locale.registrationDesc1[$store.state.locale.lang]}}</b>

						</p>
						<p>{{$store.state.locale.locale.registrationDesc2[$store.state.locale.lang]}}</p>
						<p>{{$store.state.locale.locale.registrationDesc3[$store.state.locale.lang]}}</p>
						<p>
							<b>{{$store.state.locale.locale.registrationDesc4[$store.state.locale.lang]}}<br>
								{{$store.state.locale.locale.registrationDesc5[$store.state.locale.lang]}}<br>
								{{$store.state.locale.locale.registrationDesc6[$store.state.locale.lang]}}<br></b>
						</p>
						<p style="color:red; text-align: right;">
							{{$store.state.locale.locale.required[$store.state.locale.lang]}}
						</p>
						<h3 style="text-transform: uppercase;">
							{{$store.state.locale.locale.personalInfo[$store.state.locale.lang]}}
						</h3>
					</div>
					<div class="md-layout-item md-small-size-70 md-size-40">
						<md-field>
							<label>{{$store.state.locale.locale.name[$store.state.locale.lang]}}</label>
							<md-input type="text" v-model="user.name" spellcheck="false"></md-input>
						</md-field>
					</div>
					<!-- <div class="md-layout-item md-small-size-50 md-size-20">
					<md-field>
						<label>{{$store.state.locale.locale.gender[$store.state.locale.lang]}}</label>
						<md-select :placeholder="$store.state.locale.locale.gender[$store.state.locale.lang]"
							v-model="user.gender">
							<md-option value="f">{{$store.state.locale.locale.female[$store.state.locale.lang]}}</md-option>
							<md-option value="m">{{$store.state.locale.locale.male[$store.state.locale.lang]}}</md-option>
							<md-option value="o">{{$store.state.locale.locale.other[$store.state.locale.lang]}}</md-option>
						</md-select>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-50 md-size-25">
					<md-field>
						<label>{{$store.state.locale.locale.dob[$store.state.locale.lang]}}</label>
						<md-input type="text" v-model="user.dob" style="display:none" />
						<datetime type="date" v-model="user.dob" :flow="['year', 'month', 'date']" auto></datetime>
					</md-field>
				</div> -->
					<div class="md-layout-item md-small-size-30 md-size-30">
						<md-field>
							<label>{{$store.state.locale.locale.age[$store.state.locale.lang]}}</label>
							<md-input type="number" v-model="user.age">
							</md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-40 md-size-30">
						<md-field>
							<label>{{$store.state.locale.locale.gender[$store.state.locale.lang]}}</label>
							<md-select :placeholder="$store.state.locale.locale.gender[$store.state.locale.lang]"
								v-model="user.gender" @md-selected="">
								<md-option value="f">{{"Female||ស្រី".split("||")[$store.state.locale.locale.langCode[$store.state.locale.lang]]}}</md-option>
								<md-option value="m">{{"Male||ប្រុស".split("||")[$store.state.locale.locale.langCode[$store.state.locale.lang]]}}</md-option>
								<md-option value="o">{{"Other||ផ្សេងទៀត".split("||")[$store.state.locale.locale.langCode[$store.state.locale.lang]]}}</md-option>
							</md-select>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-60 md-size-33">
						<md-field>
							<label>{{$store.state.locale.locale.phone[$store.state.locale.lang]}}</label>
							<md-input type="text" v-model="user.phone">
							</md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-33">
						<md-field>
							<label>{{$store.state.locale.locale.email[$store.state.locale.lang]}}</label>
							<md-input type="text" v-model="user.email">
							</md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-33">
						<md-field>
							<label>{{$store.state.locale.locale.institution[$store.state.locale.lang]}}</label>
							<md-input type="text" v-model="user.institution">
							</md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-40">
						<md-field>
							<label>{{$store.state.locale.locale.profession[$store.state.locale.lang]}}</label>
							<md-select :placeholder="$store.state.locale.locale.profession[$store.state.locale.lang]"
								v-model="user.profession" @md-selected="">
								<md-option v-for="profession in professionList" :value="profession.id"
									v-if="profession.id != 1">
									{{profession.name.split("||")[$store.state.locale.locale.langCode[$store.state.locale.lang]]}}
								</md-option>
							</md-select>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-60">
						<md-field>
							<label>{{$store.state.locale.locale.interest[$store.state.locale.lang]}}</label>
							<md-select :placeholder="$store.state.locale.locale.interest[$store.state.locale.lang]"
								v-model="user.interest" @md-selected="">
								<md-option v-for="interest in interestList" :value="interest.id" v-if="interest.id != 1">
									{{interest.name.split("||")[$store.state.locale.locale.langCode[$store.state.locale.lang]]}}
								</md-option>
							</md-select>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-field>
							<label>{{$store.state.locale.locale.text[$store.state.locale.lang]}}</label>
							<md-input type="text" v-model="user.text">
							</md-input>
						</md-field>
					</div>
					<!-- <div class="md-layout-item md-size-100">
					<h3 style="text-transform: uppercase;">
						{{$store.state.locale.locale.currentAddress[$store.state.locale.lang]}}</h3>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-100">
					<md-field>
						<label>{{$store.state.locale.locale.address[$store.state.locale.lang]}}</label>
						<md-input type="text" v-model="user.address"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-33">
					<md-field>
						<label>{{$store.state.locale.locale.currentProvince[$store.state.locale.lang]}}</label>
						<md-select :placeholder="$store.state.locale.locale.currentProvince[$store.state.locale.lang]"
							v-model="user.address_province" @md-selected="switchProvince('address')">
							<md-option v-for="province in provinceList" :value="province.id" v-if="province.id != 1">
								{{province.province_name.split("||")[1]}}</md-option>
						</md-select>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-33">
					<md-field>
						<label>{{$store.state.locale.locale.currentDistrict[$store.state.locale.lang]}}</label>
						<md-select :placeholder="$store.state.locale.locale.currentDistrict[$store.state.locale.lang]"
							v-model="user.address_district" @md-selected="switchDistrict('address')">
							<md-option v-for="district in districtAddressFilteredList" :value="district.id"
								v-if="district.id != 1">
								{{district.district_name.split("||")[1]}}</md-option>
						</md-select>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-33">
					<md-field>
						<label>{{$store.state.locale.locale.currentCommune[$store.state.locale.lang]}}</label>
						<md-select :placeholder="$store.state.locale.locale.currentCommune[$store.state.locale.lang]"
							v-model="user.address_commune">
							<md-option v-for="commune in communeAddressFilteredList" :value="commune.id"
								v-if="commune.id != 1">
								{{commune.commune_name}}</md-option>
						</md-select>
					</md-field>
				</div> -->
				</div>

				<div class="md-layout-item md-size-100" style="padding-top: 13px">
					<!-- <p> -->
					<!-- <md-checkbox v-model="user.agree" class="md-primary"> -->
					<!-- {{$store.state.locale.locale.confirmEmail[$store.state.locale.lang]}}</md-checkbox> -->
					<!-- </p> -->
					<p>{{$store.state.locale.locale.robot[$store.state.locale.lang]}}</p>
					<vue-recaptcha ref="captcha" sitekey="6LcR_tccAAAAAIYbzcQKe4tqan-5i3TxZUJ7D_lv"
						:loadRecaptchaScript="true" @verify="getCapt" @expired="resetCaptcha"></vue-recaptcha><br>
					<p style="line-height: 30px;">{{$store.state.locale.locale.bySubmit[$store.state.locale.lang]}} <a
							href="/privacy_policy"
							target="_blank"><b>{{$store.state.locale.locale.term[$store.state.locale.lang]}}</b></a>
						{{$store.state.locale.locale.and[$store.state.locale.lang]}} <a href="/privacy_policy"
							target="_blank"><b>{{$store.state.locale.locale.dataPolicy[$store.state.locale.lang]}}</b></a>{{$store.state.locale.locale.we[$store.state.locale.lang]}}
					</p>
					<p>{{$store.state.locale.locale.follow[$store.state.locale.lang]}}<br><a href="https://cambodiatechex.gov.kh" target="_blank"><b>Website</b></a> | <a href="https://fb.com/cambodiatechexpo" target="_blank"><b>Facebook</b></a> | <a href="https://www.instagram.com/cambodiatechexpo" target="_blank"><b>Instagram</b></a> | <a href="https://t.me/cambodiatechexpo" target="_blank"><b>Telegram</b></a> | <a href="https://www.youtube.com/channel/UCS1bGN882amxiIDxginl4ZA" target="_blank"><b>YouTube</b></a></p>


					<!-- <md-checkbox v-model="user.agree" class="md-primary" @change="checkValidation()">I agree to the Terms &
				Conditions</md-checkbox> -->
				</div>
				<div class="md-layout-item md-size-100 text-right">

					<md-button :class="{'md-raised': true, 'md-primary': true}" @click="checkValidation()">
						{{$store.state.locale.locale.register[$store.state.locale.lang]}}</md-button>


				</div>
				<md-dialog-alert :md-active.sync="infoDialog"
					:md-content="$store.state.locale.locale.invalid[$store.state.locale.lang]" md-confirm-text="OK"
					@md-confirm="onClose" />
				<md-dialog-confirm :md-active.sync="confirmDialog"
					:md-title="$store.state.locale.locale.confirmRegister[$store.state.locale.lang]"
					:md-confirm-text="$store.state.locale.locale.register[$store.state.locale.lang]"
					:md-cancel-text="$store.state.locale.locale.cancel[$store.state.locale.lang]" @md-cancel="onClose"
					@md-confirm="createuser" />

			</div>
		</div>
		<loading v-if="!isValid" />
	</div>

</template>

<script>

	import { Datetime } from 'vue-datetime';
	import { Settings } from 'luxon'
	import Compressor from 'compressorjs';
	import VueQRCodeComponent from 'vue-qr-generator'
	import VueRecaptcha from 'vue-recaptcha';
	Settings.defaultLocale = 'km'
	export default {
		components: {
			datetime: Datetime,
			VueRecaptcha,
			'qr-code': VueQRCodeComponent,
		},
		created() {

			this.registration_id = this.config.hash(32);
			this.registration_hash = this.config.sha256(this.registration_id);
			this.getSettings();
		},
		mounted() {
			// setTimeout(() => {
			// 	// console.log(grecaptcha.render);
			// 	// if(grecaptcha.render == 'function') {
			// 		grecaptcha.render("recaptcha", {sitekey: "6Le5rfsSAAAAAINrhL_oAsCIiH-heQ91vwPKtJgQ"});
			// 	// }
			// },3000)
		},
		data() {
			return {
				registration_hash: "",
				registration_id: "",
				registration_success: false,
				image: {
					id_card: "",
					vaccination_card: "",
					vaccination_card_back: "",
					personal_photo: ""
				},
				user: {
					name: "",
					age: "",
					gender: "",
					country: "",
					phone: "",
					email: "",
					profession: "",
					interest: "",
					token: "",
					institution: "",
					text: ""
					// agree: null
				},
				reference_code: "",
				isValid: false,
				infoDialog: false,
				confirmDialog: false,
				professionList: [],
				interestList: [],
				hash_id: ""
			}
		},
		methods: {
			getSettings() {
				this.$http.get(this.config.api + "/public/settings").then(data => {
					this.professionList = data.body.data.profession
					this.interestList = data.body.data.interest
					this.isValid = true;
				})
			},


			createuser() {
				// alert("go");
				if(String(this.user.interest).length == 0) this.user.interest = 1;
				if(String(this.user.profession).length == 0) this.user.profession = 1;
				let dob = (new Date(this.user.dob)).getTime();
				this.$http.post(this.config.api + "/public/ticket/post", {
					user: this.user,
					// dob,
					token: this.user.token,
					registration_id: this.registration_id
				}).then(res => {
					if (res.body.status == 'success') {
						// this.$notification.notify({
						// 	message: "Registration was successful.",
						// 	icon: 'done',
						// 	type: 'success'
						// })

						this.hash_id = res.body.data.hash_id;
						this.$router.push('/pass/'+ res.body.data.hash_id);
						this.$cookie.set('hash_id', res.body.data.hash_id, 60);
						this.registration_success = true;

					}
					this.resetCaptcha();
				})
			},
			switchProvince(p) {
				let filtered = [];
				for (let i = 0; i < this.districtList.length; i++) {
					if (this.districtList[i].province_id == this.user.address_province) {
						filtered.push(this.districtList[i])
					}
				}
				this.districtAddressFilteredList = filtered;
				this.user.address_district = "";
				this.user.address_commune = "";
			},
			switchDistrict(d) {

				let filtered = [];
				for (let i = 0; i < this.communeList.length; i++) {
					if (this.communeList[i].district_id == this.user.address_district) {
						filtered.push(this.communeList[i])
					}
				}
				this.communeAddressFilteredList = filtered;
				this.user.address_commune = "";

			},
			getCapt(token) {
				// console.log(token);
				this.user.token = token;
			},

			processFile(e, type) {
				let files = e.target.files || e.dataTransfer.files;
				if (!files.length) return;

				this.image[type] = "/loading-image.gif";
				var self = this
				new Compressor(files[0], {
					quality: 0.5,
					maxWidth: 2500,
					minWidth: 500,
					minHeight: 500,
					maxHeight: 2500,
					convertSize: 3000000,
					// The compression process is asynchronous,
					// which means you have to access the `result` in the `success` hook function.
					success(result) {
						let formData = new FormData();

						formData.append("image", result, 'imagepro');
						formData.append("registration_hash", self.registration_hash);
						self.$http.post(self.config.api + '/public/image_upload', formData).then(res => {
							if (res.body.status == 'success') {

								self.user[type + "_token"] = res.body.data.token

								var reader = new FileReader();

								reader.onload = function (e) {
									self.image[type] = e.target.result
								};

								reader.readAsDataURL(result);
							}
						})
						// self.user[type] = result;
						// console.log(result);

					},
					error(err) {
						self.$notification.notify({
							message: "Error compressing, please upload new image.",
							icon: 'error',
							type: 'danger'
						})
					},
				});




			},
			openImage(type) {
				// console.log(this.$refs);
				this.$refs[type].click();


			},
			resetCaptcha() {
				console.log("reCaptcha reset.")
				this.$refs.captcha.reset();
			},
			removeImage(type) {
				// console.log(this.$refs);
				this.image[type] = "";
				this.user[type + "_token"] = "";
				// this.checkValidation();
			},
			onClose() {
				this.infoDialog = false
				this.confirmDialog = false
			},
			checkValidation() {
				console.log(this.user);
				if (String(this.user.name).length > 0 &&
					String(this.user.age).length > 0 &&
					String(this.user.gender).length > 0 &&
					String(this.user.phone).length > 0 &&
					String(this.user.email).length > 0) {
					this.confirmDialog = true
					this.infoDialog = false
				} else {
					this.infoDialog = true
					this.confirmDialog = false
				}
			}
		}
	}
	// var onloadCallback = function () {
	// 	grecaptcha.render('recaptcha', {
	// 		'sitekey': '6Le5rfsSAAAAAINrhL_oAsCIiH'
	// 	});
	// };
</script>
<style>
	/* .product-thumbnail {
		width: 64px;
		height: 64px;
	} */

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		/* width: 100% !important; */
		width: 60% !important;
		height: auto;
	}

	.file-image-wrapper {
		/* margin: 10px; */
		width: calc(100%);
		padding-top: 8px;
		padding-bottom: 5px;
		border: 1px solid #ccc;
		border-radius: 5px;
	}

	.file-image {
		margin-top: 21px;
		text-align: center;
		/* margin-left: 10px;
		margin-right: 10px; */
		/* min-width: calc(33.3333% - 20px) !important;
		max-width: calc(33.3333% - 20px) !important;
		flex: 0 1 calc(33.3333% - 20px) !important; */
		/* padding: 0; */
	}


	/* .thumb-product {
		width: 100%;
	} */
</style>



// WEBPACK FOOTER //
// src/pages/Registration/View.vue